import COLORS, { IColorsInterface } from "styles/colors";

export const MULTIPLIER = 10;

const THEME: IThemeInterface = {
  gridBase: `${MULTIPLIER}px`,
  rawGridBase: MULTIPLIER,
  rawShiftHeight: 67,

  block: `${5 * MULTIPLIER}px`,
  lightBorder: `1px solid ${COLORS.dsGrayLighter}`,
  darkBorder: "1px solid rgba(0,0,0,0.5)",

  borderRadius: "3px",
  indicatorBorder: "3px",

  colors: COLORS,

  iconSize: {
    micro: "8px",
    tiny: "14px",
    small: "25px",
    medium: "50px",
    large: "75px",
  },

  spacing: {
    smidge: "3px",
    xsmall: `${0.5 * MULTIPLIER}px`,
    small: `${1 * MULTIPLIER}px`,
    medium: `${2 * MULTIPLIER}px`,
    large: `${3 * MULTIPLIER}px`,
    xlarge: `${4 * MULTIPLIER}px`,
  },

  text: {
    color: {
      light: COLORS.brandWhite,
      medium: COLORS.brandGray30,
      dark: COLORS.brandGray50,
    },

    primaryFamily: "Graphik-Regular, sans-serif",
    italicFamily: "Graphik-RegularItalic, sans-serif",
    mediumFamily: "Graphik-Medium, sans-serif",

    letterSpacing: {
      normal: "normal",
      smallCaps: "2.5px",
    },

    lineHeight: {
      small: "18px",
      base: "22px",
      medium: "24px",
      large: "28px",
      jumbo: "32px",
    },

    size: {
      tiny: "10px",
      small: "12px",
      base: "14px",
      large: "18px",
      largest: "24px",
      jumbo: "32px",
    },
  },

  shadows: {
    small: "0 0 5px rgba(0,0,0,0.2)",
    medium: "0 0 10px rgba(0,0,0,0.2)",
    large: "0 0 20px rgba(0,0,0,0.2)",
  },

  layering: {
    base: 0,
    tooltip: 100,
    dropdown: 500,
    overlay: 900,
    modal: 1000,
    modalTooltip: 1100,
    modalDropdown: 1500,
  },
};

interface ISpacingInterface {
  smidge: string;
  xsmall: string;
  small: string;
  medium: string;
  large: string;
  xlarge: string;
}

interface ITypeSizeInterface {
  tiny: string;
  small: string;
  base: string;
  large: string;
  largest: string;
  jumbo: string;
}

interface ITypeLetterSpacingInterface {
  normal: string;
  smallCaps: string;
}

interface ITypeLineHeightInterface {
  small: string;
  base: string;
  medium: string;
  large: string;
  jumbo: string;
}

interface ITypeColorInterface {
  light: string;
  medium: string;
  dark: string;
}

interface ITypeInterface {
  color: ITypeColorInterface;
  primaryFamily: string;
  italicFamily: string;
  mediumFamily: string;
  letterSpacing: ITypeLetterSpacingInterface;
  lineHeight: ITypeLineHeightInterface;
  size: ITypeSizeInterface;
}

interface IShadowInterface {
  small: string;
  medium: string;
  large: string;
}

interface ILayeringInterface {
  base: number;
  tooltip: number;
  dropdown: number;
  overlay: number;
  modal: number;
  modalTooltip: number;
  modalDropdown: number;
}

interface IIconSizeInterface {
  micro: string;
  tiny: string;
  small: string;
  medium: string;
  large: string;
}

interface IThemeInterface {
  block: string;
  borderRadius: string;
  darkBorder: string;
  gridBase: string;
  indicatorBorder: string;
  lightBorder: string;
  rawGridBase: number;
  rawShiftHeight: number;
  colors: IColorsInterface;
  iconSize: IIconSizeInterface;
  layering: ILayeringInterface;
  shadows: IShadowInterface;
  spacing: ISpacingInterface;
  text: ITypeInterface;
}

export { IThemeInterface, ISpacingInterface };

export default THEME;
